module.exports = __webpack_public_path__ + "static/media/telega.58a3032f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/telega.jpg
// module id = 314
// module chunks = 0